import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.677 1.617a3 3 0 0 0-3.674 2.121l-1.155 4.311a4.48 4.48 0 0 1 1.98.34l1.107-4.133a1 1 0 0 1 1.225-.708l13.523 3.624a1 1 0 0 1 .707 1.225l-5.177 19.318a1 1 0 0 1-1.224.707l-3.206-.859.597 2.231 2.091.56a3 3 0 0 0 3.674-2.121l5.177-19.319A3 3 0 0 0 36.2 5.24L22.677 1.617ZM3.8 13.269a3 3 0 0 0-2.121 3.674l5.176 19.319a3 3 0 0 0 3.674 2.121l13.523-3.623a3 3 0 0 0 2.122-3.674l-5.177-19.319a3 3 0 0 0-3.674-2.121L3.8 13.269Zm-.19 3.157a1 1 0 0 1 .708-1.225l13.523-3.623a1 1 0 0 1 1.224.707l2.567 9.58-4.863-2.131-2.96 6.557-3.575-1.184-3.057 4.627L3.61 16.426Zm4.258 15.888.919 3.43a1 1 0 0 0 1.225.707l13.523-3.623a1 1 0 0 0 .707-1.225l-1.946-7.262-4.52-1.98-2.887 6.397-3.833-1.27-3.188 4.826Zm.641-13.06a1 1 0 1 1 1.932-.517 1 1 0 0 1-1.932.517Zm.19-3.156a3 3 0 1 0 1.553 5.795 3 3 0 0 0-1.553-5.795Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const PictogramPlaceholderImages40 = createIcon(IconComponent);